import { createContext, useContext } from 'react'
import type { PeopleFlowSubTabsProps } from './PeopleFlowSwitcher'

interface PeopleFlowNavigation extends PeopleFlowSubTabsProps {
  optimisticTab?: string | null
}

// The page is nested below Suspense, Routes and sometimes RoleGuard. Context
// carries the permission-filtered navigation through all of those boundaries.
export const PeopleFlowNavigationContext = createContext<PeopleFlowNavigation>({})
export const usePeopleFlowNavigation = () => useContext(PeopleFlowNavigationContext)
